// extracted by mini-css-extract-plugin
export var activeDot = "_a4-c";
export var buttonContainer = "_a4-9";
export var channelButton = "_a4-a";
export var clickable = "_a4-d";
export var content = "_a4-0";
export var contentFull = "_a4-2";
export var contentThird = "_a4-1";
export var contentWrapper = "_a4-7";
export var description = "_a4-5";
export var heightShort = "_a4-f";
export var image = "_a4-3";
export var imageContainer = "_a4-4";
export var selectButton = "_a4-e";
export var spinnerContainer = "_a4-b";
export var titleContent = "_a4-8";
export var titleWrapper = "_a4-6";